import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider } from './context/AdminAuthContext';
import { ThemeProvider } from './context/AdminThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/AdminLayout';
import Login from './pages/AdminLogin';
import Dashboard from './pages/AdminDashboard';
import Users from './pages/Users';
import Reports from './pages/Reports';
import ReportDetail from './pages/ReportDetail';
import AdminFeedback from './pages/AdminFeedback';
import ActivityLog from './pages/ActivityLog';
import BodyParts from './pages/BodyParts';
import Modalities from './pages/Modalities';
import Techniques from './pages/Techniques';
import Settings from './pages/Settings';


const ProtectedLayout = () => (
  <ProtectedRoute>
    <Layout><Outlet /></Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route element={<ProtectedLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/users" element={<Users />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/reports/:id" element={<ReportDetail />} />
              <Route path="/reports/feedbacks" element={<AdminFeedback />} />
              <Route path="/activity-log" element={<ActivityLog />} />
              <Route path="/body-parts" element={<BodyParts />} />
              <Route path="/modalities" element={<Modalities />} />
              <Route path="/techniques" element={<Techniques />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;